import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { Card, Text, Chip, Button, useTheme } from 'react-native-paper';

const ActivityItem = ({ 
  activity, 
  onPress,
  onComplete,
  showActionButton = false
}) => {
  const theme = useTheme();

  // Durum rengini belirleyen fonksiyon
  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return theme.colors.primary;
      case 'completed':
        return theme.colors.success || '#4CAF50';
      case 'cancelled':
        return theme.colors.error;
      default:
        return theme.colors.primary;
    }
  };

  // Durum metnini belirleyen fonksiyon
  const getStatusText = (status) => {
    switch (status) {
      case 'active':
        return 'Aktif';
      case 'completed':
        return 'Tamamlandı';
      case 'cancelled':
        return 'İptal Edildi';
      default:
        return 'Bilinmiyor';
    }
  };

  // Tarih formatı
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    
    return `${day}.${month}.${year} ${hours}:${minutes}`;
  };

  return (
    <Card style={styles.card} onPress={onPress}>
      <Card.Content>
        <View style={styles.header}>
          <Text style={styles.title}>
            {activity.activityType?.name || 'Etkinlik'}
          </Text>
          <Chip 
            mode="outlined"
            style={[styles.statusChip, { borderColor: getStatusColor(activity.status) }]}
            textStyle={{ color: getStatusColor(activity.status) }}
          >
            {getStatusText(activity.status)}
          </Chip>
        </View>
        
        <View style={styles.infoRow}>
          <Text style={styles.label}>Çocuk:</Text>
          <Text style={styles.value}>{activity.child?.name} {activity.child?.surname}</Text>
        </View>
        
        <View style={styles.infoRow}>
          <Text style={styles.label}>Başlangıç:</Text>
          <Text style={styles.value}>{formatDate(activity.startTime)}</Text>
        </View>
        
        {activity.endTime && (
          <View style={styles.infoRow}>
            <Text style={styles.label}>Bitiş:</Text>
            <Text style={styles.value}>{formatDate(activity.endTime)}</Text>
          </View>
        )}
        
        <View style={styles.infoRow}>
          <Text style={styles.label}>Süre:</Text>
          <Text style={styles.value}>
            {activity.duration ? `${activity.duration} dakika` : 'Belirsiz'}
          </Text>
        </View>
        
        <View style={styles.infoRow}>
          <Text style={styles.label}>Ücret:</Text>
          <Text style={styles.value}>{activity.price ? `${activity.price} TL` : 'Belirsiz'}</Text>
        </View>
        
        {showActionButton && activity.status === 'active' && onComplete && (
          <Button 
            mode="contained" 
            style={styles.completeButton}
            onPress={() => onComplete(activity.id)}
          >
            Etkinliği Tamamla
          </Button>
        )}
      </Card.Content>
    </Card>
  );
};

const styles = StyleSheet.create({
  card: {
    marginVertical: 8,
    marginHorizontal: 12,
    elevation: 2,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    flex: 1,
  },
  statusChip: {
    height: 28,
  },
  infoRow: {
    flexDirection: 'row',
    marginVertical: 4,
  },
  label: {
    fontSize: 14,
    fontWeight: 'bold',
    width: 80,
    color: '#666',
  },
  value: {
    fontSize: 14,
    flex: 1,
  },
  completeButton: {
    marginTop: 16,
  }
});

export default ActivityItem;
